import { gql } from '@apollo/client';

const GET_ORDER_MODELS = gql`
  query GetOrderModels($id: ID!) {
    node(id: $id) {
      ... on OrderNode {
        id
        orderId
        models {
          edges {
            node {
              id
              modelReady
              modelSpecificationNode {
                id
                itemCode
                folder {
                  id
                  path {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default GET_ORDER_MODELS;
